/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminFetchExpertsApiResponse } from '../models/AdminFetchExpertsApiResponse';
import type { AdminGetCurrentExpertSubscriptionApiResponse } from '../models/AdminGetCurrentExpertSubscriptionApiResponse';
import type { AdminGetExpertBankAccountApiResponse } from '../models/AdminGetExpertBankAccountApiResponse';
import type { AdminGetExpertDetailApiResponse } from '../models/AdminGetExpertDetailApiResponse';
import type { AdminGetExpertPlansApiResponse } from '../models/AdminGetExpertPlansApiResponse';
import type { AdminGetExpertSubscriptionsApiResponse } from '../models/AdminGetExpertSubscriptionsApiResponse';
import type { ChangePersonaDto } from '../models/ChangePersonaDto';
import type { RequestDocumentsDto } from '../models/RequestDocumentsDto';
import type { UpdateVerificationDto } from '../models/UpdateVerificationDto';
import type { VerifyDocumentDto } from '../models/VerifyDocumentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminExpertManagementService {
    /**
     * Fetch experts
     * Retrieve a paginated list of experts with search, filters, and sorting. Includes verification status and admin-specific details.
     * @param search Search by name, email, phone, or display ID (EX-XX). Partial, case-insensitive
     * @param serviceType Filter by service type slugs (comma-separated)
     * @param accountStatus Filter by admin account display (comma-separated): active, inactive, suspended, hidden, not_verified. Matches the same rules as list accountStatus.
     * @param verificationStatus Filter by verification (comma-separated): pending (pending review), pending_upload, verified, rejected, requested_docs (alias resubmission_required), in_progress.
     * @param location Filter by primary location city/state (comma-separated). Matches is_primary location rows only.
     * @param fastTrackVerification Filter by fast track verification: use "true" to return only experts with is_fasttrack_verification = true
     * @param addon Filter by active add-on names (comma-separated). Only returns experts whose add-on has not expired (end_date > now)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page (max 100)
     * @param sortBy Sort by field
     * @param sortOrder Sort order
     * @param appInstalled Filter on whether a mobile login has been recorded (users.last_app_login_at). Independent of push notification consent. appInstalled=false still matches experts who have not opened the app since this was introduced and had no device row to backfill from, so it means "no mobile login on record" rather than "never installed".
     * @param signupPlatform Filter by the surface the account was created on.
     * @returns AdminFetchExpertsApiResponse Experts fetched successfully
     * @throws ApiError
     */
    public static adminExpertsControllerFetchExpertsV1(
        search?: string,
        serviceType?: string,
        accountStatus?: string,
        verificationStatus?: string,
        location?: string,
        fastTrackVerification?: string,
        addon?: string,
        page: number = 1,
        pageSize: number = 10,
        sortBy: 'full_name' | 'date_of_birth' | 'total_sessions' | 'total_clients' | 'average_rating' | 'created_at' = 'created_at',
        sortOrder: 'asc' | 'desc' = 'desc',
        appInstalled?: 'true' | 'false',
        signupPlatform?: 'app' | 'web',
    ): CancelablePromise<AdminFetchExpertsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts',
            query: {
                'search': search,
                'serviceType': serviceType,
                'accountStatus': accountStatus,
                'verificationStatus': verificationStatus,
                'location': location,
                'fastTrackVerification': fastTrackVerification,
                'addon': addon,
                'page': page,
                'pageSize': pageSize,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'appInstalled': appInstalled,
                'signupPlatform': signupPlatform,
            },
        });
    }
    /**
     * Get unique expert locations
     * Returns distinct state values from primary (is_primary) locations of expert users for filter options.
     * @returns any List of { label, value } location options
     * @throws ApiError
     */
    public static adminExpertsControllerGetUniqueExpertLocationsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/locations',
        });
    }
    /**
     * Get expert subscriptions
     * Retrieve all subscriptions for an expert, including nested plan configuration details.
     * @param id Expert UUID or display ID (EX-XX)
     * @returns AdminGetExpertSubscriptionsApiResponse Expert subscriptions retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertSubscriptionsV1(
        id: string,
    ): CancelablePromise<AdminGetExpertSubscriptionsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/subscriptions',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID format`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert current subscription
     * Retrieve the current active subscription for an expert. Returns null when no active subscription exists.
     * @param id Expert UUID or display ID (EX-XX)
     * @returns AdminGetCurrentExpertSubscriptionApiResponse Expert current subscription retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetCurrentExpertSubscriptionV1(
        id: string,
    ): CancelablePromise<AdminGetCurrentExpertSubscriptionApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/subscriptions/current',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID format`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert plans screen data
     * Retrieve all available plans along with the expert current subscription and full subscription history for a single-screen admin view.
     * @param id Expert UUID or display ID (EX-XX)
     * @returns AdminGetExpertPlansApiResponse Expert plans data retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertPlansV1(
        id: string,
    ): CancelablePromise<AdminGetExpertPlansApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/plans',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID format`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert pricing with packages
     * Returns packages for the expert with name, totalSessions, sessionsPerWeek, mode, and single/duo per-mode session prices (online, expert_location, client_location).
     * @param id Expert UUID or display ID (EX-XX)
     * @returns any Expert pricing with packages retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertPricingWithPackagesV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/pricing-packages',
            path: {
                'id': id,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert bank account (admin)
     * Returns the expert’s saved bank account with masked account number. Data is null when no bank account exists.
     * @param id Expert UUID or display ID (EX-XX)
     * @returns AdminGetExpertBankAccountApiResponse Bank account retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertBankAccountV1(
        id: string,
    ): CancelablePromise<AdminGetExpertBankAccountApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/bank-account',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID format`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert detail
     * Get full expert profile including professional info, stats, documents, and suspension details.
     * @param id Expert UUID or display ID (EX-XX)
     * @returns AdminGetExpertDetailApiResponse Expert detail retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertDetailV1(
        id: string,
    ): CancelablePromise<AdminGetExpertDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID format`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert bookings
     * Retrieve paginated list of an expert's bookings.
     * @param id Expert UUID or display ID (EX-XX)
     * @param status Filter by status (comma-separated: pending, active, completed, cancelled)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page (max 100)
     * @returns any Bookings retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertBookingsV1(
        id: string,
        status?: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/bookings',
            path: {
                'id': id,
            },
            query: {
                'status': status,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert session notes & feedback
     * Retrieve session notes and diet plans for an expert.
     * @param id Expert UUID or display ID (EX-XX)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns any Notes retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetExpertNotesV1(
        id: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/notes',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Update expert verification status
     * Update verification status with audit logging. Notes required for rejection.
     * @param id Expert UUID or display ID (EX-XX)
     * @param requestBody
     * @returns any Verification updated
     * @throws ApiError
     */
    public static adminExpertsControllerUpdateVerificationV1(
        id: string,
        requestBody: UpdateVerificationDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/experts/{id}/verification',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid status / missing notes`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Change expert persona (service type)
     * Replace the expert's service type + sub-services, wipe pricing, deactivate packages, delete old documents and request the new persona's documents, and reset verification to resubmission_required. Blocked if the expert has any bookings.
     * @param id Expert UUID or display ID (EX-XX)
     * @param requestBody
     * @returns any Persona changed; expert reset to re-verification
     * @throws ApiError
     */
    public static adminExpertsControllerChangePersonaV1(
        id: string,
        requestBody: ChangePersonaDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/experts/{id}/persona',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Has bookings / invalid or inactive service type / mismatched sub-services / no-op`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Verify expert document
     * Approve, reject, or request resubmission of an expert document.
     * @param expertId Expert UUID or display ID (EX-XX)
     * @param documentId Document UUID
     * @param requestBody
     * @returns any Document verification updated
     * @throws ApiError
     */
    public static adminExpertsControllerVerifyDocumentV1(
        expertId: string,
        documentId: string,
        requestBody: VerifyDocumentDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/experts/{expertId}/documents/{documentId}/verify',
            path: {
                'expertId': expertId,
                'documentId': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid action / missing rejection reason`,
                404: `Expert or document not found`,
            },
        });
    }
    /**
     * Request additional documents
     * Request one or more document types from an expert.
     * @param id Expert UUID or display ID (EX-XX)
     * @param requestBody
     * @returns any Documents requested
     * @throws ApiError
     */
    public static adminExpertsControllerRequestDocumentsV1(
        id: string,
        requestBody: RequestDocumentsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/experts/{id}/document-requests',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid document types`,
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert documents list
     * Retrieve all documents for an expert with their verification status.
     * @param id Expert UUID or display ID (EX-XX)
     * @returns any Documents retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetDocumentsListV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{id}/documents',
            path: {
                'id': id,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert document download URL
     * Get a signed download URL for a specific expert document.
     * @param expertId Expert UUID or display ID (EX-XX)
     * @param documentId Document UUID
     * @returns any Document URL retrieved
     * @throws ApiError
     */
    public static adminExpertsControllerGetDocumentUrlV1(
        expertId: string,
        documentId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/experts/{expertId}/documents/{documentId}/url',
            path: {
                'expertId': expertId,
                'documentId': documentId,
            },
            errors: {
                404: `Expert or document not found`,
            },
        });
    }
}
